<template>
  <div
    ref="convstooltip"
    class="con-vs-tooltip"
    @mouseleave="mouseleavex"
    @mouseenter="mouseenterx"
    @mouseup="destroy"
  >
    <transition name="tooltip-fade">
      <div
        v-if="!customText"
        v-show="active"
        ref="vstooltip"
        :class="[
          `vs-tooltip-${positionx || position}`,
          `vs-tooltip-${color}`,
          { 'after-none': noneAfter }
        ]"
        :style="style"
        class="vs-tooltip"
      >
        <h4 v-if="title">{{ title }}</h4>
        {{ text }}
      </div>

      <div
        v-if="customText"
        v-show="active"
        ref="vstooltip"
        :class="[
          `vs-tooltip-${positionx || position}`,
          `vs-tooltip-${color}`,
          { 'after-none': noneAfter }
        ]"
        :style="customStyle"

      >
        <h4 v-if="title">{{ title }}</h4>
        <p>
          Terms and Condition - Merchant should set out their own definition of
          the terms and conditions (T&C) apply to e-Gift Card for the Buyer to
          abide to, before the Buyer accepting the e-Gift Card. Below is the
          typical T&C used for the e-Gift Card:
        </p>
        <br />
        <p>
          (1) This Gift Card is only used for the payment made in Malaysian
          Ringgit. Any currency to purchase the goods or services other than
          Malaysian Ringgit is not applicable to this Gift Card.
        </p>
        <p>
          (2) This Gift Card is not redeemable for or in exchange with cash
          under any circumstances.
        </p>
        <p>
          (3) This Gift Card is valid for 12 months from the date of purchase.
        </p>
        <p>
          (4) The terms and conditions as stated in this Gift Card shall be
          subject to amendment as any time and at the sole discretion of
          Merchant Company without prior notice. Any amendment thereof shall be
          published and shall be thereupon binding on the customer.
        </p>
        <p>
          (5) Merchant Company shall not assume any responsibility or liability
          for lost, damaged, stolen or any unauthorized use of these cards.
        </p>
        <p>
          (6) Any money for topping-up in this Gift Card shall not be
          transferable to another Gift Card unless otherwise authorised by
          Merchant Company.
        </p>
        <p>
          (7) This Gift Card must be presented to the counter before any refund
          transaction can be made.
        </p>
        <p style="color: red">
          *Note: The term and condition must be checked by staff during
          redemption of gift card.
        </p>
      </div>
    </transition>
    <slot></slot>
  </div>
</template>
<script>
import utils from "@/assets/utils";
import _color from "@/assets/utils/color.js";
export default {
  name: "vx-tooltip",
  props: {
    customText: {
      default: false,
      tyle: Boolean
    },
    title: {
      default: null,
      type: [String, Number]
    },
    text: {
      default: null,
      type: [String, Number]
    },
    color: {
      default: null,
      type: String
    },
    position: {
      default: "top",
      type: String
    },
    delay: {
      default: "0s",
      type: [Number, String]
    }
  },
  data: () => ({
    cords: {},
    active: false,
    widthx: "auto",
    positionx: null,
    noneAfter: false
  }),
  computed: {
    style() {
      return {
        left: this.cords.left,
        top: this.cords.top,
        transitionDelay: this.active ? this.delay : "0s",
        background: _color.getColor(this.color, 1),
        width: this.widthx
      };
    },
    customStyle() {
      return {
        // left: this.cords.left,
        left: "25px",
        top: this.cords.top,
        transitionDelay: this.active ? this.delay : "0s",
        background: "black",
        color: "white",
        // "max-width": "250px",
        // position: "relative",
        // width: "1900px",
        position: "relative",
        width: "900px",
        "min-width": "75px",
        padding: "12px",
        "border-radius": "5px",
        
        "z-index": "52000"
      };
    }
  },
  methods: {
    mouseenterx() {
      this.active = true;
      this.$nextTick(() => {
        utils.insertBody(this.$refs.vstooltip);
        this.changePosition(this.$refs.convstooltip, this.$refs.vstooltip);
      });
    },
    mouseleavex() {
      this.active = false;
    },
    changePosition(elxEvent, tooltip) {
      this.noneAfter = false;
      this.positionx = null;
      let elx = elxEvent.closest(".con-vs-tooltip");
      let scrollTopx = window.pageYOffset || document.documentElement.scrollTop;
      let topx =
        elx.getBoundingClientRect().top + scrollTopx - tooltip.clientHeight - 4;
      let leftx =
        elx.getBoundingClientRect().left -
        tooltip.clientWidth / 2 +
        elx.clientWidth / 2;
      let widthx = elx.clientWidth;

      if (this.position == "bottom") {
        topx =
          elx.getBoundingClientRect().top + scrollTopx + elx.clientHeight + 4;
      } else if (this.position == "left") {
        leftx = elx.getBoundingClientRect().left - tooltip.clientWidth - 4;
        topx =
          elx.getBoundingClientRect().top +
          scrollTopx +
          elx.clientHeight / 2 -
          tooltip.clientHeight / 2;
        if (Math.sign(leftx) == -1) {
          leftx = elx.getBoundingClientRect().left;
          topx =
            elx.getBoundingClientRect().top + scrollTopx + elx.clientHeight + 4;
          this.positionx = "bottom";
          this.noneAfter = true;
        }
      } else if (this.position == "right") {
        leftx = elx.getBoundingClientRect().left + elx.clientWidth + 4;
        topx =
          elx.getBoundingClientRect().top +
          scrollTopx +
          elx.clientHeight / 2 -
          tooltip.clientHeight / 2;
        if (window.innerWidth - (leftx + tooltip.clientWidth) <= 20) {
          leftx =
            elx.getBoundingClientRect().left - tooltip.clientWidth / 2 - 10;
          topx =
            elx.getBoundingClientRect().top + scrollTopx + elx.clientHeight + 4;
          this.positionx = "bottom";
          this.noneAfter = true;
        }
      }
      this.cords = {
        left: `${leftx}px`,
        top: `${topx}px`,
        width: `${widthx}px`
      };
    },
    destroy() {
      this.active = false;
      this.$nextTick(() => {
        if (this.active) {
          utils.removeBody(this.$refs.vstooltip);
        }
      });
    }
  }
};
</script>
